/* eslint-disable react/prop-types */
import { Table } from 'antd';
import React, { Fragment, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CustomerActions from '@Actions/customerActions';
import { CountryCodes } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import searchIcon from '@Images/icons/icon-search.png';
import TenantActions from '@Actions/tenantActions';
import SelectUser from '@Components/Common/SelectUser';
import Helpers from '@Apis/helpers';
import './style.scss';

const SelectCustomers = ({
  getCustomers, customers, user, getCustomersLoading, orgUsers, getOrgUsers, setTableDataForCustomers, setDrawerVisible, SelectCustomersForPriceList,
}) => {
  const [searchKeyword, setSearchKeyword] = React.useState('');
  const [currentPage, setCurrentPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [selectedAssignee, setSelectedAssignee] = React.useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);

  useEffect(() => {
    getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.READ)?.join(','), () => { });
    getCustomers(
      '',
      user?.tenant_info?.tenant_id,
      1,
      15,
      null, null, '', '', SelectCustomersForPriceList,
    );
  }, []);

  useEffect(() => {
    const searchCustomer = setTimeout(() => {
      getCustomers(
        searchKeyword,
        user?.tenant_info?.tenant_id,
        currentPage,
        limit,
        null, null, selectedAssignee?.map((item) => (item?.userId))?.join(','), null, SelectCustomersForPriceList,
      );
    }, 500);
    return () => clearTimeout(searchCustomer);
  }, [searchKeyword, currentPage, selectedAssignee]);

  const columnsForSelectCustomers = [
    {
      title: 'CUSTOMER',
      key: 'customer_name',
      width: 250,
      render: (text, record) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
          }}
        >
          <H3Text
            text={(
              <React.Fragment>
                {record?.customer_info?.internal_cust_code || '-'}
              </React.Fragment>
            )}
            style={{ color: '#2D7DF7', fontWeight: '500' }}
          />
          <H3Text
            text={(
              <React.Fragment>
                {record?.customer_info?.customer_name ? record?.customer_info?.customer_name : '-'}
              </React.Fragment>
            )}
            style={{ fontWeight: '500' }}
          />
          {/* <H3Text
            text={(
              <React.Fragment>
                {record?.customer_info?.email_address ? record?.customer_info?.email_address : ''}
                {record?.customer_info?.phone_number ? (`${CountryCodes?.find((code) => code?.dial_code == record?.customer_info?.dial_code)?.flag} +${record?.customer_info?.dial_code} ${record?.customer_info?.phone_number}`) : ''}
              </React.Fragment>
            )}
            className="table-subscript"
          /> */}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'CUSTOMER TYPE',
      key: 'customer_code',
      width: 100,
      render: (text, record) => `${record?.customer_info?.customer_type
        ? record?.customer_info?.customer_type
        : '-'
        }`,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'SALES MANAGER',
      key: 'sales_manager',
      width: 150,
      render: (text, record) => (
        <React.Fragment>
          {record?.customer_info?.account_manager_info?.account_manager_id ? (`${record?.customer_info?.account_manager_info?.first_name} ${record?.customer_info?.account_manager_info?.last_name}`) : '-'}
        </React.Fragment>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
  ];

  const handleSubmit = () => {
    setTableDataForCustomers((prevData) => {
      const existingData = prevData ?? [];
      const newData = selectedRows?.map((item) => ({
        ...item,
        key: item.customer_id,
      }));
      return [...existingData, ...newData];
    });
    setDrawerVisible(false);
  };

  return (
    <div
      className="select-customers-container"
    >
      <Fragment>
        <Table
          title={() => (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <H3Text
                text={`${customers && customers.count ? customers.count : '0'
                  } Total Customers`}
                className=""
              />
              <div
                style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                }}
              >
                <div className="section-search-bar__wrapper">
                  <div className="section-search-bar">
                    <input
                      value={searchKeyword}
                      placeholder="Search for customers name.."
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          setSearchKeyword(e.target.value);
                          setCurrentPage(1);
                        }
                      }}
                      onChange={(event) => {
                        setSearchKeyword(event.target.value);
                      }}
                    />
                    <H3Image
                      src={searchIcon}
                      className="section-search-bar__icon"
                      alt="search"
                      onClick={() => {
                        setSearchKeyword(searchKeyword);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <SelectUser
                  selectedUsers={selectedAssignee}
                  onSelect={(userId) => {
                    setSelectedAssignee([...selectedAssignee, {
                      userId,
                      title: `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                      identity: orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                    }]);
                    setCurrentPage(1)
                  }}
                  onRemove={(userId) => {
                    setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                  }}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                />
              </div>
            </div>
          )}
          columns={columnsForSelectCustomers}
          bordered={false}
          size="small"
          loading={getCustomersLoading}
          scroll={{ y: 450 }}
          dataSource={
            customers && customers.customers ? customers?.customers?.map((customer) => ({
              ...customer,
              key: customer.customer_id,
            })) : []
          }
          pagination={
            customers?.count > 15
              ? {
                defaultCurrent: 1,
                current: currentPage,
                total: customers ? customers.count : 0,
                pageSize: limit,
                onChange: (page, pageSize) => {
                  setCurrentPage(page);
                  setLimit(pageSize);
                  setSelectedRowKeys([]);
                  setSelectedRows([]);
                },
                position: ['bottomRight'],
                showSizeChanger: false,
              }
              : false
          }
          rowSelection={{
            onChange: (rowKeys, rows) => {
              setSelectedRowKeys(rowKeys);
              setSelectedRows(rows);
            },
            selectedRowKeys,
          }}
        />

        <div className="custom-drawer__footer">
          <H3Button
            text={!!selectedRows?.length ? `Add ${selectedRows?.length} Participants` : "Add Participants"}
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => handleSubmit()}
            isLoading={getCustomersLoading}
            disabled={!selectedRows?.length || getCustomersLoading}
            style={{
              width: '200px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </Fragment>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, CustomerReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  getCustomersLoading: CustomerReducers.getCustomersLoading,
  customers: CustomerReducers.customers,
  orgUsers: TenantReducers.orgUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomers: (keyword, tenantId, page, limit, customerId, callback, accountManagerIds, selectedCustomerIds, excludeCustomerIds) => dispatch(CustomerActions.getCustomers(keyword, tenantId, page, limit, customerId, callback, accountManagerIds, selectedCustomerIds, excludeCustomerIds)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
});

SelectCustomers.propTypes = {
  getCustomers: PropTypes.func,
  getCustomersLoading: PropTypes.bool,
  customers: PropTypes.any,
  user: PropTypes.any,
  orgUsers: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectCustomers));
